import { useDispatch, useSelector } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import HybridField from '../../../../components/HybridField/HybridField';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button/Button';
import { theme } from '../../../../styles/theme';
import { retrievePasswordFetchAction } from '../../../../store/fetchActions/retrievePassword';
import Modal from '../../../../components/Modal/Modal';
import { blockUserFetchAction } from '../../../../store/fetchActions/blockUserActions';
import { useState } from 'react';
import TextInput from '../../../../components/TextInput/TextInput';
import {
  ButtonContainer,
  SmallerModal,
  OptionsContainer,
  TitleOptions,
} from '../../styles/GerenciarClientes.styles';
import { useForm } from 'react-hook-form';
import { MdErrorOutline } from 'react-icons/md';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import SelectInput from '@material-ui/core/Select/SelectInput';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
const {
  mainColor,
  secondaryColor,
  rbmBlack,
  rbmWhite,
  dangerColor,
  warningColor,
} = theme.colors;

export default function AddressCollum({
  control,
  isEditing,
  cancel,
  handleSubmit,
  errors,
}) {
  const { usersData } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const recuperarSenha = (CPFCNPJ) => {
    const param = { CPFCNPJ: CPFCNPJ };
    dispatch(retrievePasswordFetchAction(param));
  };

  const { handleSubmit: handleBlockUser, control: controlBlockUser } = useForm(
    {},
  );

  const [modalBlockUser, setModalBlockUser] = useState(false);

  const blockUser = ({ justificativa }) => {
    let param = { MOTIVO: justificativa, CPFUSUARIO: usersData.CPFCNPJ };
    dispatch(blockUserFetchAction(param, closeModalBlockUser));
  };

  const brasilStateOptions = [
    { ID: 'AC', NOME: 'AC' },
    { ID: 'AL', NOME: 'AL' },
    { ID: 'AP', NOME: 'AP' },
    { ID: 'AM', NOME: 'AM' },
    { ID: 'BA', NOME: 'BA' },
    { ID: 'CE', NOME: 'CE' },
    { ID: 'DF', NOME: 'DF' },
    { ID: 'ES', NOME: 'ES' },
    { ID: 'GO', NOME: 'GO' },
    { ID: 'MA', NOME: 'MA' },
    { ID: 'MT', NOME: 'MT' },
    { ID: 'MS', NOME: 'MS' },
    { ID: 'MG', NOME: 'MG' },
    { ID: 'PA', NOME: 'PA' },
    { ID: 'PB', NOME: 'PB' },
    { ID: 'PR', NOME: 'PR' },
    { ID: 'PE', NOME: 'PE' },
    { ID: 'PI', NOME: 'PI' },
    { ID: 'RJ', NOME: 'RJ' },
    { ID: 'RN', NOME: 'RN' },
    { ID: 'RS', NOME: 'RS' },
    { ID: 'RG', NOME: 'RG' },
    { ID: 'RR', NOME: 'RR' },
    { ID: 'SC', NOME: 'SC' },
    { ID: 'SP', NOME: 'SP' },
    { ID: 'SE', NOME: 'SE' },
    { ID: 'TO', NOME: 'TO' },
  ];

  const openModalBlockUser = () => setModalBlockUser(true);
  const closeModalBlockUser = () => setModalBlockUser(false);
  return (
    <Styled.InformationContainer>
      <h3>ENDEREÇO</h3>
      <HybridField
        control={control}
        title={'Endereço'}
        value={usersData.ENDERECO}
        disabled={!isEditing}
        width={'38vw'}
        name={'ENDERECO'}
        error={errors.ENDERECO && true}
        margin={'1.389vw 0 0 0'}
      />
      <Styled.Row>
        <HybridField
          control={control}
          title={'Número'}
          value={usersData.NUMERO}
          disabled={!isEditing}
          width={'5.208vw'}
          name={'NUMERO'}
          type={'number'}
          error={errors.NUMERO && true}
          inputProps={{ maxLength: 4 }}
          margin={'1.389vw 0 0 0'}
        />

        <HybridField
          control={control}
          title={'Complemento'}
          value={usersData.COMPLEMENTO}
          disabled={!isEditing}
          width={'11.806vw'}
          name={'COMPLEMENTO'}
          error={errors.COMPLEMENTO && true}
          margin={'1.389vw  0 0 1.389vw'}
          required={false}
        />
        <HybridField
          control={control}
          title={'Bairro'}
          value={usersData.BAIRRO}
          disabled={!isEditing}
          width={'18.3vw'}
          name={'BAIRRO'}
          error={errors.BAIRRO && true}
          margin={'1.389vw 0 0 1.389vw'}
        />
      </Styled.Row>
      <Styled.Row>
        <HybridField
          control={control}
          title={'Cidade'}
          value={usersData.CIDADE}
          disabled={!isEditing}
          width={'20.806vw'}
          name={'CIDADE'}
          error={errors.CIDADE && true}
          margin={'1.389vw 0 0 0'}
        />
        {/* <HybridField
          control={control}
          title={'UF'}
          value={usersData.UF}
          disabled={!isEditing}
          width={'4.514vw'}
          name={'UF'}
          inputProps={{ maxLength: 2 }}
          margin={'1.389vw 0 0 1.389vw'}
        /> */}
        <OptionsContainer>
          <TitleOptions>UF</TitleOptions>
          <SelectOptions
            control={control}
            options={brasilStateOptions}
            name={'UF'}
            disabled={!isEditing}
            height={'3.3vw'}
            initialName={usersData.UF}
            initialValue={usersData.UF}
          />
        </OptionsContainer>
      </Styled.Row>
      <Styled.ButtonContainer>
        {isEditing ? (
          <>
            <Button
              backgroundColor={rbmWhite}
              width={'12.153vw'}
              height={'3.333vw'}
              hoverBGColor={secondaryColor}
              hoverColor={rbmWhite}
              color={rbmBlack}
              onClick={cancel}
            >
              <span>CANCELAR</span>
            </Button>
            <Button
              backgroundColor={secondaryColor}
              width={'12.153vw'}
              height={'3.333vw'}
              hoverBGColor={mainColor}
              hoverColor={rbmBlack}
              color={rbmWhite}
              onClick={handleSubmit}
            >
              <span>SALVAR</span>
            </Button>
          </>
        ) : (
          <>
            <Button
              backgroundColor={rbmWhite}
              width={'12.153vw'}
              height={'3.333vw'}
              hoverBGColor={dangerColor}
              hoverColor={rbmWhite}
              color={secondaryColor}
              onClick={() => openModalBlockUser()}
            >
              <span>BLOQUEAR USUÁRIO</span>
            </Button>
            <Button
              backgroundColor={rbmWhite}
              width={'12.153vw'}
              height={'3.333vw'}
              hoverBGColor={secondaryColor}
              hoverColor={rbmWhite}
              color={rbmBlack}
              onClick={() => recuperarSenha(usersData.CPFCNPJ)}
            >
              <span>RECUPERAR SENHA</span>
            </Button>
          </>
        )}
      </Styled.ButtonContainer>
      <Modal open={modalBlockUser} close={closeModalBlockUser}>
        <SmallerModal>
          <MdErrorOutline color={warningColor} size={'6.944vw'} />
          <h3>Bloquear usuário</h3>
          <h5>Tem certeza que deseja bloquear o usuário?</h5>
          <h4>Justificativa</h4>
          <form onSubmit={handleBlockUser(blockUser)}>
            <TextInput
              margin={'0'}
              variant={'outlined'}
              name={'justificativa'}
              width={'28.342vw'}
              multiline={true}
              minRows={3}
              required={true}
              size="large"
              control={controlBlockUser}
              inputProps={{ maxLength: 100 }}
            />
            <ButtonContainer>
              <Button
                backgroundColor={rbmWhite}
                width={'13.792vw'}
                height={'3.125vw'}
                hoverBGColor={secondaryColor}
                hoverColor={rbmWhite}
                color={secondaryColor}
                onClick={() => closeModalBlockUser()}
              >
                <span>Voltar</span>
              </Button>
              <Button
                backgroundColor={secondaryColor}
                width={'13.792vw'}
                height={'3.125vw'}
                hoverBGColor={dangerColor}
                hoverColor={rbmWhite}
                color={rbmWhite}
                type={'submit'}
                roleName={'button-confirmar-negar'}
              >
                <span>Bloquear</span>
              </Button>
            </ButtonContainer>
          </form>
        </SmallerModal>
      </Modal>
    </Styled.InformationContainer>
  );
}

AddressCollum.propTypes = {
  control: PropTypes.any,
  isEditing: PropTypes.bool,
  cancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  errors: PropTypes.object,
};
